import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { EnvService } from '../configurations/env.service';
import { Observable, of } from 'rxjs';
import { DetailProject } from "../../_models/projets/projet/DetailProject";
import { DetailSlotSearchResponse } from "../../_models/projets/cotation/DetailSlotSearchResponse";
import { HistoryEventResponse } from "../../_models/history/HistoryEventResponse";

import { OrderCreationResponse } from "../../_models/orders/OrderCreationResponse";
import { OrderDetailSlotSearchRequest } from '../../_models/orders/OrderDetailSlotSearchRequest';
import { OrderLog } from 'src/app/_models/orders/OrderLog';
import { OrderPrintRequest } from '../../_models/orders/OrderPrintRequest';
import { OrderRequest } from '../../_models/orders/OrderRequest';
import { OrderSendPlannerRequest } from '../../_models/orders/OrderSendPlannerRequest';
import { OrderStatusRequest } from '../../_models/orders/OrderStatusRequest';

import { QuotationResponse } from "../../_models/orders/QuotationResponse";
import { OrderStatusResponse } from "../../_models/orders/OrderStatusResponse";
import { OrderDateResponse } from "../../_models/orders/OrderDateResponse";
import { CotationModeValues } from "../../_models/projets/cotation/CotationMode";
import { CountOrderByTpe } from "../../_models/orders/CountOrderByTpe";
import { CountClientOrder } from "../../_models/orders/CountClientOrder";
import { SearchOrderResponse } from "../../_models/orders/SearchOrderResponse";
import { OrderSearchRequest } from "../../_models/orders/OrderSearchRequest";
import { OrderChangeRequest } from "../../_models/orders/OrderChangeRequest";
import { OrderChangeResponse } from "../../_models/orders/OrderChangeResponse";
import { OrderTerminateResponse } from "../../_models/orders/OrderTerminateResponse";
import { OrderTerminateRequest } from "../../_models/orders/OrderTerminateRequest";
import { OrderResponseWithAction } from "../../_models/orders/OrderResponseWithAction";
import { OrderOptionRequest } from "../../_models/orders/OrderOptionRequest";
import { EventResponse } from '../../_models/orders/EventResponse';

@Injectable({ providedIn: 'root' })
export class OrderService {
   private env = inject(EnvService);
   private apiURL = this.env?.readConfig()?.apiUrl;

   constructor(
      private http: HttpClient,
   ) {
   }

   adOrder(orderRequest: OrderRequest): Observable<OrderCreationResponse> {
      return this.http.post<OrderCreationResponse>(`${this.apiURL}/order/addOrder`, orderRequest, { withCredentials: true });
   }

   getMaxRemise(orderRequest: OrderRequest): Observable<number> {
      return this.http.post<number>(`${this.apiURL}/order/discount/max`, orderRequest, { withCredentials: true });
   }

   setOrderStatus(orderStatusRequest: OrderStatusRequest): Observable<any> {
      return this.http.post(`${this.apiURL}/order/status`, orderStatusRequest, { withCredentials: true });
   }

   getCountOrders(status: string): Observable<number> {
      return this.http.get<number>(`${this.apiURL}/order/count/${status}`);
   }

   getOrders(orderSearchRequest: OrderSearchRequest): Observable<SearchOrderResponse> {
      return this.http.post<SearchOrderResponse>(`${this.apiURL}/order/list`, orderSearchRequest, { withCredentials: true });
   }

   getcountOrdersClient(countClientOrder: CountClientOrder): Observable<number> {
      return this.http.post<number>(`${this.apiURL}/order/count/client`, countClientOrder, { withCredentials: true });
   }

   getCountOrdersByType(countOrderByTpe: CountOrderByTpe): Observable<number> {
      return this.http.post<number>(`${this.apiURL}/order/count/type`, countOrderByTpe, { withCredentials: true });
   }

   // TODO: à implémenter dans le back
   getOrdersClientForDisplay(): Observable<string> {
      return of('');
   }

   // TODO: à implémenter dans le back
   getCancelationFeeConfirmationDisplay(): Observable<string> {
      return of('test');
   }

   // TODO: à implémenter dans le back
   getPlanTitleForDisplay(): Observable<string> {
      return of('Détail des écrans');
   }

   getOrderNature(typeQuotation: CotationModeValues): Observable<string[]> {
      return this.http.get<string[]>(`${this.apiURL}/order/nature/quotationType/${typeQuotation}`);
   }

   getOrderDiffusion(typeQuotation: CotationModeValues): Observable<string[]> {
      return this.http.get<string[]>(`${this.apiURL}/order/diffusion/diffusionType/${typeQuotation}`);
   }

   getOrderById(id: string): Observable<OrderResponseWithAction> {
      return this.http.get<OrderResponseWithAction>(`${this.apiURL}/order/id/${id}`);
   }

   getOrderSubnature(typeQuotation: CotationModeValues, nature: string): Observable<string[]> {
      return this.http.get<string[]>(`${this.apiURL}/order/subnature/quotationType/${typeQuotation}/nature/${nature}`);
   }
   getOrderEvent(): Observable<EventResponse[]> {
      return this.http.get<EventResponse[]>(`${this.apiURL}/event`, {
         params: {
            "status": "ACTIVE"
         }
      });
   }

   getOrderStatusList(): Observable<OrderStatusResponse[]> {
      return this.http.get<OrderStatusResponse[]>(`${this.apiURL}/order/status/list`);
   }

   getOptionAuthorized(orderOptionRequest: OrderOptionRequest): Observable<boolean> {
      return this.http.post<boolean>(`${this.apiURL}/order/option/authorized`, orderOptionRequest, { withCredentials: true });
   }

   getOrderOptionValidityDateByQuotationType(typeQuotation: CotationModeValues): Observable<OrderDateResponse> {
      return this.http.get<OrderDateResponse>(`${this.apiURL}/order/optionValidityDate/quotationType/${typeQuotation}`);
   }

   terminateOrder(orderTerminateRequest: OrderTerminateRequest): Observable<OrderTerminateResponse> {
      return this.http.post<OrderTerminateResponse>(`${this.apiURL}/order/terminate`, orderTerminateRequest, { withCredentials: true });
   }

   changeOrder(orderChangeRequest: OrderChangeRequest): Observable<OrderChangeResponse> {
      return this.http.post<OrderChangeResponse>(`${this.apiURL}/order/change`, orderChangeRequest, { withCredentials: true });
   }

   cancelOrder(orderStatusRequest: OrderStatusRequest): Observable<boolean> {
      return this.http.post<boolean>(`${this.apiURL}/order/status/cancel`, orderStatusRequest, { withCredentials: true });
   }

   //validateOrder(name: string , status: string): Observable<any> {
   //  return this.http.get(`${this.apiURL}/order/validate/${name}/${status}`);
   //}

   getDetail(name): Observable<QuotationResponse> {
      return this.http.get<QuotationResponse>(`${this.apiURL}/order/detail/${name}`);
   }
   downloadCSVFile(id: number): Observable<any> {
      return this.http.get(`${this.apiURL}/order/download/csv/${id}`, { responseType: 'text' });
   }

   downloadMediPilotFile(id: number) {
      return this.http.get(`${this.apiURL}/order/download/mediapilot/${id}`);
   }

   downloadPdfFile(orderPrintRequest: OrderPrintRequest): Observable<any> {
      // const params = new HttpParams().append('order-client-siren', orderRequest.siren).append('order-name', orderRequest.name).append('email', orderRequest.agentEmail);
      // if (orderRequest.siret)
      // params.append('order-client-siret', orderRequest.siret);
      return this.http.post(`${this.apiURL}/order/download/pdf`, orderPrintRequest, {
         observe: 'response',
         responseType: 'blob'
      });
      // return this.http.get(`${this.apiURL}/order/download/pdf`, {params,  observe: 'response',responseType: 'blob'});
   }

   getDetailSlot(orderDetailSlotSearchRequest: OrderDetailSlotSearchRequest): Observable<DetailSlotSearchResponse> {
      return this.http.post<DetailSlotSearchResponse>(`${this.apiURL}/order/detailslots`, orderDetailSlotSearchRequest);
   }

   getHistoryEvent(entityModified: string, idEntityModified: string): Observable<HistoryEventResponse[]> {
      const headers = new HttpHeaders().append('entity-modified', entityModified).append('id-entity', idEntityModified);
      return this.http.get<HistoryEventResponse[]>(`${this.apiURL}/historyEvent/getHistory`, { headers });
   }

   getCotation(id: string): Observable<DetailProject> {
      return this.http.get<DetailProject>(`${this.apiURL}/order/cotation/${id}`);
   }

   sendXMLFile(orderSendPlannerRequest: OrderSendPlannerRequest): Observable<any> {
      return this.http.post(`${this.apiURL}/order/send/mediaapi/top`, orderSendPlannerRequest);
   }

   /*
      sendXMLFileGateway(orderSendPlannerRequest: OrderSendPlannerRequest): Observable<any> {
         return this.http.post(`${this.apiURL}/order/send/gateway/mediaapi/top`, orderSendPlannerRequest);
      }*/

   getOrderLogs(orderId: string): Observable<OrderLog[]> {
      const url = `${this.apiURL}/v2/order/${orderId}/ext/log`;
      return this.http.get<OrderLog[]>(url);
   }

   getOrderLogRequest(orderId: string, logId: number): Promise<any> {
      const url = `${this.apiURL}/v2/order/${orderId}/ext/log/${logId}/request`;
      return this.http.get<any>(url, { responseType: 'blob' } as object).toPromise();
   }

   getOrderLogResponse(orderId: string, logId: number): Promise<any> {
      const url = `${this.apiURL}/v2/order/${orderId}/ext/log/${logId}/response`;
      return this.http.get<any>(url, { responseType: 'blob' } as object).toPromise();
   }

   addBackOfficeOrder(requestBody): Observable<any> {
      return this.http.post<any>(`${this.apiURL}/v2/order/`, requestBody, { withCredentials: true });
   }

   getIncomingMail(projectId: string): Observable<any> {
      const url = `${this.apiURL}/ext/ringcentral/incomingmail/${projectId}`;
      return this.http.get<any>(url);
   }

   getIncomingMailV2(projectId: string | number): Observable<any> {
      const url = `${this.apiURL}/incomingmail/`;
      return this.http.get<any>(url, {params: { projectId: String(projectId) }, withCredentials: true});
   }

   exportOrders(format: 'csv' | 'xlsx', orderSearchRequest: OrderSearchRequest): Observable<Blob> {
      const params = new HttpParams().set('format', format);
      return this.http.post(`${this.apiURL}/order`, orderSearchRequest,
         {
            params,
            responseType: 'blob',
            withCredentials: true
         }
      );
   }


}
